// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IsolationUnitStatus } from './IsolationUnitStatus';
import {
  IsolationUnitStatusFromJSON,
  IsolationUnitStatusFromJSONTyped,
  IsolationUnitStatusToJSON,
  IsolationUnitStatusToJSONTyped,
} from './IsolationUnitStatus';
import type { Metadata } from './Metadata';
import {
  MetadataFromJSON,
  MetadataFromJSONTyped,
  MetadataToJSON,
  MetadataToJSONTyped,
} from './Metadata';
import type { IsolationUnitSpec } from './IsolationUnitSpec';
import {
  IsolationUnitSpecFromJSON,
  IsolationUnitSpecFromJSONTyped,
  IsolationUnitSpecToJSON,
  IsolationUnitSpecToJSONTyped,
} from './IsolationUnitSpec';

/**
 *
 * @export
 * @interface IsolationUnitEntity
 */
export interface IsolationUnitEntity {
  /**
   *
   * @type {string}
   * @memberof IsolationUnitEntity
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof IsolationUnitEntity
   */
  environment?: string;
  /**
   *
   * @type {string}
   * @memberof IsolationUnitEntity
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof IsolationUnitEntity
   */
  managementSource?: string;
  /**
   *
   * @type {Metadata}
   * @memberof IsolationUnitEntity
   */
  metadata?: Metadata;
  /**
   *
   * @type {IsolationUnitSpec}
   * @memberof IsolationUnitEntity
   */
  spec?: IsolationUnitSpec;
  /**
   *
   * @type {IsolationUnitStatus}
   * @memberof IsolationUnitEntity
   */
  status?: IsolationUnitStatus;
  /**
   *
   * @type {string}
   * @memberof IsolationUnitEntity
   */
  updatedAt?: string;
}

/**
 * Check if a given object implements the IsolationUnitEntity interface.
 */
export function instanceOfIsolationUnitEntity(
  value: object,
): value is IsolationUnitEntity {
  return true;
}

export function IsolationUnitEntityFromJSON(json: any): IsolationUnitEntity {
  return IsolationUnitEntityFromJSONTyped(json, false);
}

export function IsolationUnitEntityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IsolationUnitEntity {
  if (json == null) {
    return json;
  }
  return {
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    environment: json['environment'] == null ? undefined : json['environment'],
    id: json['id'] == null ? undefined : json['id'],
    managementSource:
      json['management_source'] == null ? undefined : json['management_source'],
    metadata:
      json['metadata'] == null ? undefined : MetadataFromJSON(json['metadata']),
    spec:
      json['spec'] == null
        ? undefined
        : IsolationUnitSpecFromJSON(json['spec']),
    status:
      json['status'] == null
        ? undefined
        : IsolationUnitStatusFromJSON(json['status']),
    updatedAt: json['updated_at'] == null ? undefined : json['updated_at'],
  };
}

export function IsolationUnitEntityToJSON(json: any): IsolationUnitEntity {
  return IsolationUnitEntityToJSONTyped(json, false);
}

export function IsolationUnitEntityToJSONTyped(
  value?: IsolationUnitEntity | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    created_at: value['createdAt'],
    environment: value['environment'],
    id: value['id'],
    management_source: value['managementSource'],
    metadata: MetadataToJSON(value['metadata']),
    spec: IsolationUnitSpecToJSON(value['spec']),
    status: IsolationUnitStatusToJSON(value['status']),
    updated_at: value['updatedAt'],
  };
}
